import React from "react";
import { Mail, MapPin, Phone } from "lucide-react";
import { REC_EMAIL, STUDENT_ADMISSION_EMAIL1, STUDENT_ADMISSION_EMAIL2 } from "../constants";

const Footer = () => (
  <footer className="bg-slate-900 text-slate-300 mt-auto border-t-4 border-amber-600">
    <div className="max-w-7xl mx-auto px-6 py-12 grid sm:grid-cols-2 md:grid-cols-3 gap-8">
      <div className="md:col-span-1">
        <h3 className="text-white font-serif font-bold mb-3 text-2xl tracking-tight">AIIMS Mangalagiri</h3>
        <p className="text-sm leading-relaxed text-slate-400">
          An Institute of National Importance under Ministry of Health & Family Welfare, Government of India.
        </p>
      </div>
      <div className="space-y-4 text-sm">
        <h4 className="font-semibold text-slate-100 text-base uppercase tracking-wider">Contact Us</h4>
        <div className="flex items-start space-x-3 text-slate-400">
          <MapPin className="h-5 w-5 text-amber-500 flex-shrink-0 mt-0.5" />
          <span>Mangalagiri, Guntur District,<br />Andhra Pradesh, India - 522503</span>
        </div>
      </div>
      <div className="space-y-4 text-sm">
        <h4 className="font-semibold text-slate-100 text-base uppercase tracking-wider">Inquiries</h4>
        <div className="space-y-4">
          <div className="flex items-start space-x-3 text-slate-400">
            <Mail className="h-5 w-5 text-amber-500 flex-shrink-0 mt-0.5" />
            <div className="flex flex-col">
              <span className="text-xs font-semibold text-slate-400 uppercase tracking-wider">Recruitment</span>
              <a href={`mailto:${REC_EMAIL}`} className="text-slate-200 hover:text-amber-500 transition-colors duration-200 break-all">
                {REC_EMAIL}
              </a>
            </div>
          </div>
          <div className="flex items-start space-x-3 text-slate-400">
            <Mail className="h-5 w-5 text-amber-500 flex-shrink-0 mt-0.5" />
            <div className="flex flex-col space-y-1">
              <span className="text-xs font-semibold text-slate-400 uppercase tracking-wider">Student Query</span>
              <a href={`mailto:${STUDENT_ADMISSION_EMAIL1}`} className="text-slate-200 hover:text-amber-500 transition-colors duration-200 break-all">
                {STUDENT_ADMISSION_EMAIL1}
              </a>
              <a href={`mailto:${STUDENT_ADMISSION_EMAIL2}`} className="text-slate-200 hover:text-amber-500 transition-colors duration-200 break-all">
                {STUDENT_ADMISSION_EMAIL2}
              </a>
            </div>
          </div>
          <div className="flex items-center space-x-3 text-slate-400 pt-1 border-t border-slate-800">
            <Phone className="h-5 w-5 text-amber-500 flex-shrink-0" />
            <a href="tel:08632346100" className="text-slate-200 hover:text-amber-500 transition-colors duration-200">
              Recruitment Query: 08645280037
            </a>
          </div>
        </div>
      </div>
    </div>
    <div className="bg-slate-950 text-center py-5 border-t border-slate-800">
      <p className="text-xs text-slate-500 tracking-wide">
        © {new Date().getFullYear()} All India Institute of Medical Sciences, Mangalagiri. All Rights Reserved.
      </p>
    </div>
  </footer>
);

export default Footer;
